import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import { useTheme } from "../../context/ThemeContext";

function NtOnboardingHeader({ title, subtitle }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  return (
    <View style={styles.head}>
      <NtText style={styles.title}>{title}</NtText>
      {subtitle ? <NtText style={styles.subtitle}>{subtitle}</NtText> : null}
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    head: { marginBottom: 36, maxWidth: 640 },
    title: {
      fontSize: 46,
      lineHeight: 48,
      fontWeight: "800",
      letterSpacing: -1.2,
      color: t.text,
      marginBottom: 12,
    },
    subtitle: {
      fontSize: 15,
      color: t.textDim,
      lineHeight: 23,
      maxWidth: 620,
    },
  });

export default NtOnboardingHeader;
